import React from "react";
import "./titleCard.sass";

export interface IEngageEventTemplateCardProps {
  title: string;
  onClick: () => void;
}

const TitleCard: React.FC<IEngageEventTemplateCardProps> = ({
  title,
  onClick
}) => {
  return (
    <div className="title-card card" onClick={onClick}>
      <div>{title}</div>
    </div>
  );
};

export default TitleCard;
